import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  VStack
} from "@chakra-ui/react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { ReactComponent as Logo } from "assets/logo.svg";
import { getEula } from "api/webservice/content";
import { updateUser } from "api/webservice/users";
import { options } from "api/contentful/options";
import { useUser } from "context/user";
import { useToast } from "hooks";
import { BasicLayout } from "layouts";
import { Card } from "components";

const Eula: React.FC = () => {
  const [eulaContent, setEulaContent] = useState<any>([]);
  const { user, setUser } = useUser()!;
  const toast = useToast();
  const history = useHistory();

  useEffect(() => {
    getEula()
      .then(result => {
        const content = result.fields?.description ?? null;
        if (!content) return false;
        setEulaContent(content);
      });
  }, []);

  const handleAccept = async (): Promise<any | null> => {
    await updateUser({ id: user.id, has_accepted_eula: true })
      .then(updatedUser => {
        setUser(updatedUser);
        history.push("/profile");
      })
      .catch(error => {
        toast({
          title: "Error submitting acceptance",
          description: error.response.data.response,
          status: "error"
        });
      });
  };

  return (
    <BasicLayout showBackgroundImage backPath="/profile">
      <Container maxW="1080px" minH="100vh" px={[4, 12]} centerContent>
        <VStack spacing={8} width="100%">
          <Box w="200px" mt={24}>
            <Logo />
          </Box>
          {eulaContent && (
            <>
              <Heading size="lg" textAlign="center">
                {eulaContent.title}
              </Heading>
              <Card p={[3, 12]} mb={24}>
                {eulaContent.content &&
                  documentToReactComponents(eulaContent.content, options)}
                <Flex justifyContent="center" mt={4}>
                  <Button variant="blue" size="md" onClick={handleAccept}>
                    I Agree
                  </Button>
                </Flex>
              </Card>
            </>
          )}
        </VStack>
      </Container>
    </BasicLayout>
  );
};

export default Eula;
